export default "__VITE_ASSET__B_rk0OFu__"